<div class="main-content h-full pt-[0!important]">
    <h2 class="mb-5">{{ 'choose_number_guest' | transloco }}</h2>
    <div class="flex gap-2 flex-wrap justify-center">
        <ng-container *ngIf="!otherFlg; else inputTemp">
            <div class="badge p-4 w-[20%] text-center" *ngFor="let item of items" (click)="handleSubmit(item)">
                {{ item }}
            </div>
        </ng-container>
        <ng-template #inputTemp>
            <tui-input-number [formControl]="amountCtrl" class="w-full">
                {{ 'number_guest' | transloco }}
            </tui-input-number>
            <tui-error [formControl]="amountCtrl" [error]="[] | tuiFieldError | async"></tui-error>
        </ng-template>
    </div>
    <div class="flex items-center justify-center mt-4 gap-2">
        <button tuiButton size="m" type="button" (click)="otherFlg = !otherFlg">
            {{ (otherFlg ? 'choose_number' : 'enter_number_other') | transloco }}
        </button>
        <button tuiButton appearance="accent" size="m" type="button" *ngIf="otherFlg" (click)="handleSubmit()">
            {{ 'confirm' | transloco }}
        </button>
    </div>
</div>
